import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import App from './App.vue';
import router from './router';

import 'primeicons/primeicons.css';

// Custom Broker theme
import { Broker } from './theme/broker';

// Custom styles
import './style.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);

// PrimeVue 4 configuration with styled mode and custom Broker theme
app.use(PrimeVue, {
    unstyled: false,
    theme: {
        preset: Broker,
    },
});

// PrimeVue services
app.use(ToastService as any);
app.use(ConfirmationService as any);

app.mount('#app');
